import {translations} from 'presentation/translations-new';
import {AuthorizationOdontoStatusEnum} from '../constants';

const {status} = translations['pt-br'].privateFlow.requestAuthorizations;

export const formatOdontoStatusTitle = (statusAuthorization: string): string => {
	if (statusAuthorization === AuthorizationOdontoStatusEnum.UNFORMATTED_FINISHED) {
		return status.finished;
	}

	if (statusAuthorization === AuthorizationOdontoStatusEnum.UNFORMATTED_UNDER_ANALYSIS) {
		return status.underOdontoAnalysis;
	}

	return statusAuthorization;
};
